<template>
  <div class="main-wrapper">
    <NavBar />
    <SideBar />
    <slot />
    <Footer />
  </div>
</template>
<style>
</style>
<script>
import firebase from "firebase/app";
import "firebase/messaging";

import swal from 'sweetalert'
import NProgress from 'nprogress'
import NavBar from '../../components/layout/NavBar.vue'
import SideBar from '../../components/layout/SideBar.vue'
import Footer from '../../components/layout/Footer.vue'
import stislaScript from '../../mixins/stislaScript'

export default {
  data() {
    return {

    }
  },
  components: {
    NavBar, SideBar, Footer
  },
  mixins: [stislaScript],
  methods: {
    getProfil() {
      if (!this.$store.getters.getUserProfile) {
        NProgress.start()
        this.$store.dispatch('fetchUserProfile').then(res => {
          this.profile = this.$store.getters.getUserProfile

          if(!this.profile.id_kelamin){
            swal({
              title: "Perhatian",
              text: "Harap lengkapi data anda pada halaman profil sebelum membuat permohonan dokumen kependudukan",
              icon: "warning",
              buttons: "Ok"
            })
          }
          setTimeout(() => NProgress.done(), 500)
        }).catch(err => {
          // console.log(err)
          if (err.response.status === 401) { // tokennya udah expired: Unauthenticated
            this.$store.dispatch('logoutUser')
            localStorage.removeItem('authService')
            localStorage.removeItem('fcmToken')
            sessionStorage.clear()
            window.location.href = '/login'
          } else if (err.response.status === 500) { // server error
            this.$router.push({ path: '/500' })
          }
        })
      }
    },
    sendLink() {
      let data = new FormData()
      data.append('data', '1')
      this.$store.dispatch('sendLinkEmailVerification', data)
    },
    getUser() {
      this.$store.dispatch('fetchUser').then(res => {
        let user = this.$store.getters.getUser

        if (!user.email_verified_at) {
          this.sendLink()
          this.$router.push({ path: '/verifikasi-email' })
          return false
        }

        if (user.is_aktif === 0) {
          this.$router.push({ path: '/kependudukan/validasi-otp' })
        }

        // get nama desa user, dari rbac_user, karena tempat dia kerja kemungkinan beda dengan id desa di id_pendudk

        this.$store.dispatch('fetchDesa', { id_desa: user.id_desa }).then(res => {
          if (res.data.status) {
            this.$store.dispatch('setDesaUser', res.data.data[0]);
          }
        })

      }).catch(err => {
        // console.log(err)
        if (err.response.status === 401) {
          this.$store.dispatch('logoutUser')
        } else if (err.response.status === 500) {
          this.$router.push({ path: '/500' })
        }
      })
    },
    initFirebaseMessaging() {
      if (!this.$store.getters.getFcmToken) {
        try {
          firebase
            .messaging()
            .requestPermission()
            .then(() => {
              console.log("Notification permission granted")
              firebase
                .messaging()
                .getToken()
                .then((token) => {
                  this.$store.dispatch('setFcmToken', token)
                  this.updateUserToken(token)
                  this.receiveMessage()
                })
            })
            .catch((err) => {
              console.log("Unable to get token ", err)
            })
        } catch (e) {
          console.log(e)
        }
      }
    },
    updateUserToken(token) {
      this.$store.dispatch('storeFirebaseTokenWeb', { firebase_token: token }).then(res => {
        if (res.data.status) {
          console.log('Success Set FCM Token')
        } else {
          console.log('Error Set FCM Token', res.data.message)
        }
      })
      // .catch(err => console.log(err))
    },
    receiveMessage() {
      try {
        firebase.messaging().onMessage((payload) => {
          // console.log("payload ", payload)
          // this.showToast(payload);
        })
      } catch (e) {
        console.log('error receive payload')
      }
    }
  },
  created() {
    // penduduk
    this.getProfil()

    // cek verfikasi email, otp user, udah valid gak
    this.getUser()
  },
  mounted() {
    // user ttd biar kesimpen
    this.$store.dispatch('fetchUserTtd').then(res => {
      if (res.data.status) {
        this.$store.dispatch('setUserTtd', res.data.data)
      }
    })

    // initFirebaseApp
    this.initFirebaseMessaging()

    this.renderStislaScript()

    // check apakah localStorage authnya kosong, refresh
    if (!localStorage.authService) {
      // kalo kosong, suruh login
      swal({
        title: "Informasi",
        text: "Sesi sudah berakhir. Harap login kembali",
        icon: "warning",
        buttons: {
          ok: {
            text: "Ok",
            value: "ok",
          },
        }
      }).then(val => {
        sessionStorage.clear()
        window.location = '/login'
      })
    }
  }
}
</script>